import styled from 'styled-components';

export const StyledMain = styled.main`
  &:empty + * {
    display: none;
  }
`;
